module.exports = __webpack_public_path__ + "img/RS.ef6cb438.png";